import { API_CURRENCY, Currency } from '../constants';
import { ApiResponse } from '../utils';
import axios from 'axios';

export const CurrencyService = {
  currency: async (currency: Currency): Promise<ApiResponse<any>> => {
    return await axios.get(`${API_CURRENCY}/${currency}`);
  },
};
